import { Injectable } from '@angular/core';
import { MetadataResource } from './metadata.resource';

@Injectable({
  providedIn: 'root',
})
export class LanguageLevelService extends MetadataResource {
  constructor() {
    super('language-level');
  }
}
